const CLIENT_TENANT_KEY = "client_tenant";

/** Base do portal do cliente: `/bytefy/cliente` ou `/cliente` (sem tenant na URL). */
export function getClientPortalBase(): string {
  const t = localStorage.getItem(CLIENT_TENANT_KEY)?.trim();
  if (t) return `/${encodeURIComponent(t)}/cliente`;
  return "/cliente";
}

export function setClientTenant(tenant: string | null | undefined) {
  if (tenant?.trim()) localStorage.setItem(CLIENT_TENANT_KEY, tenant.trim());
  else localStorage.removeItem(CLIENT_TENANT_KEY);
}

export function getStoredClientTenant(): string | null {
  return localStorage.getItem(CLIENT_TENANT_KEY);
}
